import React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./spa.css";
import { installChunkReloadGuard } from "./chunk-reload";
import { i18nReady } from "./i18n";
import { ScrollToTop } from "./ScrollToTop";
import { SpaApp } from "./SpaApp";
import { canonicalHttpsUrl } from "./https-redirect";

const root = document.getElementById("root");
const httpsUrl = canonicalHttpsUrl(window.location, import.meta.env.PROD);
const router = createBrowserRouter([{ path: "*", element: <><ScrollToTop /><SpaApp /></> }]);

if (!root) {
  throw new Error("Missing SPA root element");
}

// 发版后旧页面会去要已经不存在的 chunk（生产实测每次发版都有）。要在挂载之前装，
// 否则首屏路由自己就先崩了。
installChunkReloadGuard();

if (httpsUrl) {
  window.location.replace(httpsUrl);
} else {
  // 等当前语言的资源落地再挂载,否则首屏会闪一次未翻译的 key。
  void i18nReady.then(() => {
    createRoot(root).render(
      <React.StrictMode>
        <RouterProvider router={router} />
      </React.StrictMode>
    );
  });
}
